<div class="suggestion">
  <tds-message *ngFor="let item of suggestion.Messages" variant="warning" [header]="item.Header">{{ item.MessageText }}</tds-message>
  <div *ngIf="suggestion.Alternatives.length > 0" class="suggestion-options">
    <h4>FPC {{ suggestion.StartObject.Family }} · {{ suggestion.StartObject.FamilyDescription }}</h4>
    <p>Choose a new execution for each configuration in one of the groups below, then add the suggestion.</p>
    <conversion-alternative *ngFor="let item of suggestion.Alternatives" [alternative]="item" (applied)="applied.emit()"></conversion-alternative>
  </div>
</div>
